import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL_OLD,
  FLAG_FETCH,
  FLAG_EDIT,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'newlobby' })
export default class Newlobby extends VuexModule {
  listFlag: any = [];

  @Mutation
  mutateFlag(flag) {
    this.listFlag = flag;
  }

  @Action({ commit: 'mutateFlag' })
  FetchFlag(params) {
    return Vue.axios({
      url: BASE_URL_OLD + FLAG_FETCH,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const item = data.data;
          return item;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditFlag(params) {
    return Vue.axios({
      url: BASE_URL_OLD + FLAG_EDIT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
